import {
  ReactNode,
  useRef,
  useEffect,
  cloneElement,
  Children,
  isValidElement,
  ReactElement,
} from 'react'
import styled from 'styled-components'
import { useState } from 'react'

const Container = styled.div`
  position: relative;
  max-height: 50vh;
  overflow: hidden;
  position: relative;
`

const Content = styled.div`
    transition: transform 0.5s;
    will-change: transform;
`

const MaskBottom = styled.div`
    pointer-events: none;
  position: absolute;
  content: '';
  width: 100%;
  height: 50%;
  bottom: 0;
  background: linear-gradient(
    0deg,
    ${({ theme }) => `rgba(${theme.backgroundColorRgb}, 1)`} 35%,
    ${({ theme }) => `rgba(${theme.backgroundColorRgb}, 0)`} 100%
  );
`

const MaskTop = styled(MaskBottom)`
  bottom: auto;
  top: 0;
  background: linear-gradient(
    0deg,
    ${({ theme }) => `rgba(${theme.backgroundColorRgb}, 0)`} 35%,
    ${({ theme }) => `rgba(${theme.backgroundColorRgb}, 1)`} 100%
  );
`

const Button = styled.button<{secondary?: boolean}>`
  position: absolute;
  z-index: 1;
  bottom: 0;
  border: none;
  background: ${({ theme, secondary }) => `rgb(${secondary ? theme.secondaryColor : theme.mainColor})`};
  color: white;
  padding: 0.5em 1em;
  border-radius: 5px;
  font-family: var(--font-sans-serif);
  font-size: 1em;
  cursor: pointer;
`

export const ExpandableContent = ({
  children,
  maxHeight,
  secondary,
}: {
  children: ReactNode
  maxHeight: number
  secondary?: boolean
}) => {
  const childRef = useRef<HTMLDivElement | null>(null)
  const [showButton, setShowButton] = useState(false)
  const [page, setPage] = useState(0)
  const [offsetTop, setOffsetTop] = useState(0)
  const boxHeightLimit = window.innerHeight * maxHeight
  const boxHeight = childRef?.current?.offsetHeight || 0
  const pages = Math.floor(boxHeight/(boxHeightLimit - 95))

  useEffect(() => {
    if (childRef.current) {
      const height = childRef?.current?.offsetHeight
      if (height > boxHeightLimit - 95) {
        setShowButton(true)
      }
    }
  }, [])

  const childWithRef = Children.map(children, (child) => {
    if (isValidElement(child)) {
      return cloneElement(child as ReactElement, { ref: childRef })
    }
  })

  useEffect(() => {
    setOffsetTop(page * (boxHeightLimit - 120))
  }, [page])

  return (
    <Container>
      <Content style={{ transform: `translate3d(0, ${-offsetTop}px, 0)` }}>
        {childWithRef}
      </Content>
      {showButton && (
        <Button
            secondary={secondary}
          onClick={() => {
            setPage((oldPage) => (boxHeight/(boxHeightLimit - 95)) - page > 1 ? oldPage + 1 : 0)
          }}
        >
          En lire davantage
        </Button>
      )}
      {(showButton && page < pages) && <MaskBottom />}
      {/* {showButton && page > 0 && <MaskTop />} */}
    </Container>
  )
}
